// frontend/modules/in-app-notifications/routes.tsx
import React from 'react';
import { RouteObject } from 'react-router-dom';
import { InAppNotificationListView } from './views/InAppNotificationListView';
import { InAppNotificationDetailView } from './views/InAppNotificationDetailView';

export const inAppNotificationRoutes: RouteObject[] = [
    {
        path: '/notifications',
        children: [
            {
                index: true,
                element: <InAppNotificationListView />
            },
            {
                path: ':id',
                element: <InAppNotificationDetailView />
            }
        ]
    }
];
